module.exports = __webpack_public_path__ + "static/img/cpfa.4c32489.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/cpfa.png
// module id = kJgT
// module chunks = 1